// extracted by mini-css-extract-plugin
export var CancelIcon = "index-module--CancelIcon--b4d48";
export var SmallMessage = "index-module--SmallMessage--474f6";
export var Title = "index-module--Title--3956f";